import styled from 'styled-components';
import { getContrastColor as getContrast } from '../../utils/colorUtils';

/* ── Layout ──────────────────────────────────────────────────── */

export const PageWrapper = styled.div`
  width: calc(100% + 40px);
  margin-left: -20px;
  margin-right: -20px;
  padding: 0 20px 60px;
  min-height: 80vh;
`;

export const HeaderCard = styled.div`
  background: ${p => p.bg};
  border: 1px solid ${p => p.accent}99;
  border-radius: 12px;
  padding: 20px 24px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const TrasteroLogo = styled.img`
  width: 56px; 
  height: 56px; 
  border-radius: 10px;
  object-fit: contain; 
  flex-shrink: 0;
`;
export const HeaderLeft  = styled.div`
  display: flex; 
  align-items: center; 
  gap: 14px;
`;
export const HeaderMeta  = styled.div`
  display: flex; 
  flex-direction: column; 
  gap: 2px;
`;
export const TrasteroName = styled.h1`
  color: ${p => getContrast(p.bg)}; 
  font-size: 20px; 
  font-weight: 700; 
  margin: 0;
`;
export const TrasteroSub  = styled.p`
  color: ${p => getContrast(p.bg)}88; 
  font-size: 13px; 
  margin: 0;
`;
export const HeaderRight  = styled.div`
 display: flex;
 align-items: center; 
 gap: 12px;
 @media (max-width: 640px) {
    grid-column: 1;
    justify-self: stretch;
    justify-content: space-between;
    width: 100%;
  }
`;
export const CountBadge   = styled.div`color: ${p => p.accent}; font-size: 14px; font-weight: 500;`;

export const BackBtn = styled.button`
  background: none;
  border: 1px solid ${p => p.accent}44;
  color: ${p => p.accent};
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
  &:hover { background: ${p => p.accent}22; }
`;

/* ── Grid ────────────────────────────────────────────────────── */

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, var(--card-w, 249px));
  justify-content: center;
  gap: 10px;
  padding-top: 20px;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    padding: 8px;
  }
`;

/* ── Tarjeta ─────────────────────────────────────────────────── */

export const CardWrapper = styled.div`
  position: relative;
  width: var(--card-w, 249px); 
  cursor: pointer;
  overflow: hidden; 
  border-radius: 10px;
  background: ${p => p.bg}; 
  border: 2px solid rgb(247, 247, 251);
  display: flex; 
  flex-direction: column;
  &:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.35); }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const CardInfo = styled.div`
  padding: 10px 12px; display: flex; flex-direction: column; gap: 4px;
  border-top: 2px solid rgb(247, 247, 251);
  flex: 1;
`;

export const CardPrice  = styled.div`font-size: 18px; font-weight: 800; color: ${p => p.accent}; line-height: 1.1;`;
export const CardNombre = styled.div`font-size: 18px; font-weight: 700; color: ${p => p.color}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`;
export const CardDesc   = styled.div`font-size: 13px; color: ${p => p.color}; opacity: 0.65; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.4;`;

export const CardBadges = styled.div`display: flex; gap: 5px; flex-wrap: wrap; margin-top: auto; padding-top: 6px;`;
export const CardBadge  = styled.span`font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 10px; background: ${p => p.accent}22; color: ${p => p.accent}; border: 1px solid ${p => p.accent}44;`;

export const ChatIconBtn = styled.button`
  background: none; border: none; cursor: pointer;
  color: inherit; font-size: 16px; flex-shrink: 0;
  padding: 0; opacity: 1; line-height: 1;
  width: 24px; height: 24px;
  display: flex; align-items: center; justify-content: center;
  position: relative;
  transition: opacity 0.15s;
  &:hover { opacity: 0.55; }
  &:hover::after {
    content: 'Enviar mensaje';
    position: absolute; top: calc(100% + 6px); right: 0;
    background: rgba(0,0,0,0.85); color: #fff;
    font-size: 11px; font-weight: 500; white-space: nowrap;
    padding: 4px 8px; border-radius: 6px; pointer-events: none; z-index: 10;
  }
`;

/* ── Modal detalle ───────────────────────────────────────────── */

export const Overlay = styled.div`
  position: fixed; inset: 0; background: rgba(0,0,0,0.6);
  z-index: 2000; display: flex; align-items: center; justify-content: center; padding: 20px;
`;

export const DetailBox = styled.div`
  background: ${p => p.bg}; border: 2px solid rgba(255,255,255,0.12);
  border-radius: 14px;
  max-width: 700px; width: 95%; max-height: 90vh;
  overflow: visible; position: relative;
  display: flex; flex-direction: column;
`;

export const DetailScroll = styled.div`
  overflow-y: auto; padding: 32px;
  display: flex; flex-direction: column; gap: 20px;
  max-height: 90vh;
`;

export const DetailClose = styled.button`
  position: absolute; top: 14px; right: 14px;
  background: transparent; border: none; font-size: 20px; cursor: pointer;
  color: ${p => getContrast(p.bg)}88;
  &:hover { color: ${p => getContrast(p.bg)}; }
`;

export const DetailTitle = styled.h2`color: ${p => p.color}; font-size: 22px; font-weight: 800; margin: 0 0 8px;`;
export const DetailPrice = styled.div`color: ${p => p.accent}; font-size: 26px; font-weight: 800; margin-bottom: 10px;`;
export const DetailMeta  = styled.div`display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 12px;`;

export const MetaTag = styled.span`
  background: ${p => (p.accent || '#888')}22;
  border: 1px solid ${p => (p.accent || '#888')}44;
  color: ${p => p.accent || '#888'};
  border-radius: 20px; padding: 3px 10px; font-size: 12px; font-weight: 600;
`;

export const DetailDesc = styled.p`
  color: ${p => p.color}; opacity: 0.85; line-height: 1.6; margin: 0 0 16px; font-size: 14px;
`;

export const ShareRow = styled.div`
  display: flex; align-items: center; gap: 10px;
  padding-top: 14px;
  border-top: 1px solid rgba(255,255,255,0.08);
  margin-top: 4px;
`;

export const ShareLabel = styled.span`
  font-size: 12px; color: rgba(255,255,255,0.4); flex-shrink: 0;
`;

export const ShareBtn = styled.a`
  display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 34px;
  border-radius: 8px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.08);
  text-decoration: none;
  position: relative;
  transition: background 0.2s, border-color 0.2s;
  &:hover { background: ${p => p.accent || 'rgba(255,255,255,0.18)'}; border-color: transparent; }
  svg { display: block; }

  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    background: #1a1a2e;
    border: 1px solid rgba(255,255,255,0.12);
    color: rgba(255,255,255,0.9);
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 9999;
  }
  &:hover::after { opacity: 1; }
`;

/* ── Lightbox ────────────────────────────────────────────────── */

export const LbOverlay = styled.div`
  position: fixed; inset: 0; background: rgba(0,0,0,0.92);
  display: flex; align-items: center; justify-content: center;
  z-index: 3000; cursor: zoom-out;
`;

export const LbImg = styled.img`
  max-width: 92vw; max-height: 88vh; object-fit: contain; border-radius: 6px; cursor: default;
`;

export const LbNav = styled.button`
  position: absolute; top: 50%; transform: translateY(-50%);
  ${p => p.prev ? 'left: 20px;' : 'right: 20px;'}
  background: rgba(255,255,255,0.15); border: none; color: #fff;
  font-size: 32px; width: 48px; height: 48px; border-radius: 50%;
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  opacity: ${p => p.disabled ? 0.2 : 1};
  pointer-events: ${p => p.disabled ? 'none' : 'auto'};
`;

export const LbClose = styled.button`
  position: absolute; top: 16px; right: 16px;
  background: rgba(255,255,255,0.15); border: none; color: #fff;
  font-size: 18px; width: 36px; height: 36px; border-radius: 50%; cursor: pointer;
`;

export const LbDots = styled.div`
  position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%);
  display: flex; gap: 8px;
`;

export const LbDot = styled.button`
  width: 8px; height: 8px; border-radius: 50%; border: none; cursor: pointer;
  background: ${p => p.active ? '#fff' : 'rgba(255,255,255,0.35)'};
  padding: 0; transition: background 0.2s;
`;

/* ── Toggle + Vista plana ────────────────────────────────────── */

export const ToggleBtn = styled.button`
  background: transparent; color: ${p => p.accent};
  border: 1px solid ${p => p.accent}88; border-radius: 8px;
  padding: 7px 12px; font-size: 13px; font-weight: 600;
  cursor: pointer; display: flex; align-items: center; gap: 6px;
  transition: all 0.2s;
  &:hover { background: ${p => p.accent}22; }
`;

export const FlatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 190px);
  justify-content: center;
  gap: 10px;

  @media (max-width: 600px) {
    /* CAMBIO CLAVE: minmax(0, 1fr) obliga a que las 2 columnas midan el 50% exacto del móvil */
    grid-template-columns: repeat(2, minmax(0, 1fr)); 
    padding: 12px 8px 80px;
    gap: 8px; /* Simplificado para móvil */
  }
`;

export const FlatCard = styled.div`
  position: relative; width: 190px; border-radius: 10px;
  overflow: hidden; background: ${p => p.bg};
  border: 2px solid rgb(247, 247, 251); cursor: pointer;
  &:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.35); }
    @media (max-width: 600px) {
    width: 100% !important; /* Abandona anchos fijos y se adapta a la columna */
    max-width: 100% !important;
  }
`;

export const FlatImg = styled.img`width: 100%; height: 140px; object-fit: cover; display: block;`;

/* ── Buscador interno ────────────────────────────────────────── */

export const SearchWrap = styled.div`
  display: flex; align-items: center; gap: 10px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 10px; padding: 0 14px; margin-bottom: 20px;
  transition: border-color 0.2s;
  &:focus-within { border-color: ${p => p.accent}88; }
`;

export const SearchInput = styled.input`
  flex: 1; background: none; border: none; outline: none;
  color: inherit; font-size: 14px; padding: 12px 0;
  &::placeholder { color: inherit; opacity: 0.35; }
`;

/* ── Estado vacío ────────────────────────────────────────────── */

export const EmptyState = styled.div`
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; min-height: 40vh; gap: 14px; text-align: center;
`;


export const VendidoRibbon = styled.div`
  position: absolute;
  top: 12px;
  right: -28px;
  width: 110px;
  background: #e74c3c;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
  padding: 4px 0;
  transform: rotate(45deg);
  z-index: 99;
  letter-spacing: 0.05em;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
`;